export const API_URL = {
    BASE_API_URL: {
        UserManagement: process.env.REACT_APP_APIBASEPATH_USERMANAGEMENT,
        Configuration: process.env.REACT_APP_APIBASEPATH_CONFIGURATION,
        LogAndMessage: process.env.REACT_APP_APIBASEPATH_LOGANDMESSAGE,
        Notification: process.env.REACT_APP_APIBASEPATH_NOTIFICATION,
        RevenueManagement: process.env.REACT_APP_APIBASEPATH_REVENUECONFIGURATION,
        SnapShot: process.env.REACT_APP_SNAPSHOT,
        CRM: process.env.REACT_APP_APIBASEPATH_CRM,
        CRM_REPORT_PDF_BASEPATH: process.env.REACT_APP_APIBASEPATH_CRM_REPORT_PDF,
        PY_SOCKET_CHAT_BASEPATH: process.env.REACT_APP_SOCKET_CHAT_BASEPATH,
        PY_CHAT_BASEPATH: process.env.REACT_APP_CHAT_BASEPATH,
        NODEAPIDOCLINK: process.env.REACT_APP_NODEAPIDOCLINK,
        ADMINAPI: process.env.REACT_APP_APIBASEPATH_ADMINAPI,
    },
    LOGIN_URL: "v1/Login/getclientuserlogindetails",
    MULTI_LOGIN_URL: "v1/Login/getclientmultiuserlogindetails",
    CLIENT_BY_PRIMARY_KEY: "v1/Client/getbyprimarykey",
    SSOUSEREMAILVERIFICATION: "v1/Login/ssouseremailverification",

    RESENDOTP: "v1/Login/resendotp",
    VERIFY2FA: "v1/Login/verify2fa",

    GETAPIKEY: "v1/Client/getapikey",
    GENERATEAPIKEY: "v1/Client/generateapikey",

    FORGOT_PASSWORD: "v1/Login/forgotpassword",
    UPDATE_PASSWORD: "v1/Login/updatepassword",
    LOGINSWITCHSET: "v1/Login/loginswitchset",
    LOGINSWITCHGET: "v1/Login/loginswitchget",
    CLIENT_USER_LOGIN_BY_ID: "v1/Login/getclientuserlogindetailsbyuserid",

    DEMO_REQUEST: {
        SEND_OTP: "Login/demorequestsendotp",
        VERIFY_OTP: "Login/demorequestverifyotp",
        AVAILABLE_SLOTS: "Login/demorequestavailableslots",
        SAVE: "Login/demorequestsave",
    },

    PROPERTY_TERM: {
        GET_PROPERTY_LIST: "v1/Properties/getlist",
        DELETE_PROPERTY_DATA: "v1/Properties/delete",
        Get_PROPERTY_DATA: "v1/Properties/getbyprimarykey",
        SAVE_PROPERTY_DATA: "v1/Properties/update",
        PROPERTY_ASSOCIATION_TAXES:
            "v1/PropertiesAssociationTaxes/getlistwithalltaxes",
        SAVE_PROPERTY_ASSOCIATION_TAXES: "v1/PropertiesAssociationTaxes/save",
        GET_PROPERTY_TAXES: "v1/PropertiesTaxes/getlist",
        SAVE_PROPERTY_TAX: "v1/PropertiesTaxes/save",
        GET_PROPERTY_ROOM_TYPES: "v1/PropertiesRoomTypes/getlist",
        SAVE_PROPERTY_ROOM_TYPES: "v1/PropertiesRoomTypes/save",
        GET_AV_EQUIPMENT_LIST: "v1/PropertiesAVEquipment/getlist",
        SAVE_AV_EQUIPMENT: "v1/PropertiesAVEquipment/save",
        GET_PROPERTY_FOOD_LIST: "v1/PropertiesFood/getlist",
        SAVE_PROPERTY_FOOD_LIST: "v1/PropertiesFood/save",
        GET_PROPERTY_BEVERAGES_LIST: "v1/PropertiesBeverage/getlist",
        SAVE_PROPERTY_BEVERAGES_LIST: "v1/PropertiesBeverage/save",
        SAVE_PROPERTIES_ROOM_MEETING: "v1/PropertiesRoomMeeting/save",
        GET_PROPERTIES_ROOM_MEETING: "v1/PropertiesRoomMeeting/getlist",
        GET_DROPDOWN_LIST: "v1/Properties/getlistdropdown",
        GET_USER_LIST_BY_PROPERTY_ID: "v1/Properties/getlistuserbypropertyid",
        GET_PROPERTY_LIST_BY_USER_ID: "v1/Properties/getlistpropertybyuserid",
        GET_PROPERTY_ALL_DETAILS_HOTEL_VIEW:
            "v1/Properties/getbyprimarykeywithalldetails",
        GET_DASHBOARD_COUNTS: "v1/Properties/getdashboardcountsbyprimarykey",
    },

    CRM_ATTACHMENTS: {
        SAVE_ATTACHMENTS_DATA: "v1/Attachments/save",
        GET_ATTACHMENTS_DATA: "v1/Attachments/getlist",
        DELETE_ATTACHMENTS_DATA: "v1/Attachments/delete",
        GET_ATTACHMENTS_DATA_WITH_PRIMARY_KEY: "v1/Attachments/getbyprimarykey",
    },

    CRM_ACCOUNTS: {
        GET_ACCOUNTS_DATA: "v1/Accounts/getlist",
        GET_ACCOUNTS_DATA_LAST_WORKED: "v1/Accounts/getlistlastworked",
        GET_ACCOUNT_DASHBOARD_COUNT: "v1/Accounts/getdashboardcounts",
        SAVE_ACCOUNTS_DATA: "v1/Accounts/save",
        GET_BY_PRIMARY_KEY: "v1/Accounts/getbyprimarykeywithdetails",
        ACCOUNT_OWNER_LIST: "v1/Properties/getlistuserbypropertyid",
        DELETE_ACCOUNT_DATA: "v1/Accounts/delete",
        UPDATE_TOP: "v1/Accounts/updatetop",
        UPDATE_TARGET: "v1/Accounts/updatetarget",
        UPDATE_TARGET_GROWTH: "v1/Accounts/updatetargetgrowth",
        GET_OPPORTUNITY_FROM_ACCOUNT: "v1/Accounts/getopportunityfromaccount",
        GET_NIGHT_SOLD_AND_ADR_DATA: "crm/get_property_summery",
        GET_RESERVATION_DETAIL: "crm/reservation_detail",
    },

    CRM_OPPORTUNITY: {
        GET_RFP_LIST: "v1/RFPOpportunity/getlist",
        DELETE_RFP_DATA: "v1/RFPOpportunity/delete",
        SAVE_RFP_DATA: "v1/RFPOpportunity/save",
        GET_BY_PRIMARY_KEY: "v1/RFPOpportunity/getbyprimarykeywithdetails",
        GET_LNR_LIST: "v1/LNROpportunity/getlist",
        DELETE_LNR_DATA: "v1/LNROpportunity/delete",
        LNR_GET_BY_PRIMARY_KEY: "v1/LNROpportunity/getbyprimarykeywithdetails",
        SAVE_LNR_DATA: "v1/LNROpportunity/save",
        GROUP_GET_BY_PRIMARY_KEY: "v1/GroupOpportunity/getbyprimarykeywithdetails",
        GROUP_SAVE_DATA: "v1/GroupOpportunity/save",
        OPPORTUNITY_OWNER_LIST: "v1/Properties/getlistuserbypropertyid",
        MEETING_AND_CATERING_GET_BY_PRIMARY_KEY:
            "v1/MeetingCateringOpportunity/getbyprimarykeywithdetails",
        MEETING_AND_CATERING_SAVE_DATA: "v1/MeetingCateringOpportunity/save",
        GET_GROUP_LIST: "v1/GroupOpportunity/getlist",
        DELETE_GROUP_DATA: "v1/GroupOpportunity/delete",
        GET_MEETING_AND_CATERING_LIST: "v1/MeetingCateringOpportunity/getlist",
        DELETE_MEETING_CATERING_DATA: "v1/MeetingCateringOpportunity/delete",
        RFP_COPY_DATA: "v1/RFPOpportunity/copy",
        RFP_STATUS_CHANGE: "v1/RFPOpportunity/statuschange",
        LNR_STATUS_CHANGE: "v1/LNROpportunity/statuschange",
        GROUP_STATUS_CHANGE: "v1/GroupOpportunity/statuschange",
        MEETING_CATERING_STATUS_CHANGE:
            "v1/MeetingCateringOpportunity/statuschange",
        LNR_COPY_DATA: "v1/LNROpportunity/copy",
        GROUP_COPY_DATA: "v1/GroupOpportunity/copy",
        MEETING_AND_CATERING_COPY_DATA: "v1/MeetingCateringOpportunity/copy",
        SAVE_ACTUAL_GRID_DATA: "v1/RFPOpportunity/saveactualratelist",
        GET_ACTUAL_GRID_DATA: "v1/RFPOpportunity/getactualratelist",
        GET_RFP_DASHBOARD_COUNT: "v1/RFPOpportunity/getdashboardcounts",
        GET_LNR_DASHBOARD_COUNT: "v1/LNROpportunity/getdashboardcounts",
        GET_GROUP_DASHBOARD_COUNT: "v1/GroupOpportunity/getdashboardcounts",
        GET_MEETING_AND_CATERING_DASHBOARD_COUNT:
            "v1/MeetingCateringOpportunity/getdashboardcounts",
        GET_MEETING_ROOM_TYPE_BY_PROPERTY_ID: "v1/PropertiesRoomMeeting/getlist",
        GET_ROOM_TYPE_BY_PROPERTY_ID: "v1/PropertiesRoomTypes/getlist",
        LNR_GENERATE_WORD_FILE: "v1/LNROpportunity/LNRGenerateWordFile",
        GROUP_GENERATE_WORD_FILE: "v1/GroupOpportunity/GroupGenerateWordFile",
        MEETING_AND_CATERING_GENERATE_WORD_FILE:
            "v1/MeetingCateringOpportunity/MeetingCateringGenerateWordFile",
    },

    CRM_DASHBOARD: {
        DASHBOARD_COUNT: "v1/Dashboard/getdashboardcounts",
        GET_SALES_FUNNEL: "v1/Dashboard/getsalesfunnel",
        GET_ACTIVITY_CHART_COUNT: "v1/Dashboard/dashboardactivitychartcount",
        GET_OPPORTUNITY_ANTICIPATED_CHART:
            "v1/Dashboard/getopportunityanticipatedchart",
        GET_ACTIVITY_GOAL_CHART: "v1/Dashboard/getactivitygoalchart",
        GET_RFP_SALES_FUNNEL: "v1/Dashboard/getrfpsalesfunnel",
        GET_LNR_SALES_FUNNEL: "v1/Dashboard/getlnrsalesfunnel",
        GET_GRP_SALES_FUNNEL: "v1/Dashboard/getgroupsalesfunnel",
        GET_MTCT_SALES_FUNNEL: "v1/Dashboard/getmeetingsalesfunnel",
        GET_DASHBOARD_CHART_ACTIVITY_LIST:
            "v1/Dashboard/dashboardchartlistactivity",
    },

    KPI: {
        GET_LIST: "v1/KPI/getlist",
        SAVE: "v1/KPI/save",
    },

    DYNAMIC_RATE_CONFIG: {
        GET_CONFIG_LIST: "v1/DynamicRateConfig/dynamicrateconfiggetlist",
        SAVE_CONFIG: "v1/DynamicRateConfig/dynamicrateconfigsave",
        GET_JUMP_LIST: "v1/DynamicRateConfig/dynamicratejumpgetlist",
        SAVE_JUMP_LIST: "v1/DynamicRateConfig/dynamicratejumpsave",
        JUMP_LIST_FOR_VIEW: "v1/DynamicRateConfig/dynamicratejumpgetlistforview",
        JUMP_SAVE_BY_ID: "v1/DynamicRateConfig/dynamicratejumpsavebyid",
    },

    PROJECT_TERM: {
        GET_CATEGORY_LIST: "v1/ProjectTerm/getcategorylist",
        GET_LIST: "v1/ProjectTerm/getlist",
        GET_BY_PRIMARY_KEY: "v1/ProjectTerm/getbyprimarykey",
        SAVE: "v1/ProjectTerm/save",
        DELETE: "v1/ProjectTerm/delete",
        GET_LIST_BY_MULTIPLE_CATEGORY: "v1/ProjectTerm/getlistbymulticategory",
        GET_LIST_BY_MULTIPLE_CATEGORY_AND_PROPERTY:
            "v1/ProjectTerm/getlistbymulticategoryandproperty",
        GET_LIST_OF_TIME_ZONE: "v1/ProjectTerm/getlistoftimezone",
        GET_LIST_OF_CHANNELS: "v1/ProjectTerm/getlistofchannels",
    },

    CRM_ACCOUNT_RULES: {
        GET_ACCOUNT_RULES_LIST: "v1/AccountRule/getlist",
        GET_ACCOUNT_RULE_SETTINGS: "v1/AccountRuleSettings/getbyprimarykey",
        SAVE_UPDATED_DETAILS: "v1/AccountRuleSettings/update",
        SAVE_DISABLED: "v1/AccountRuleSettings/updatedisabled",
    },

    ACCOUNT: {
        GET_ACCOUNT_LIST: "v1/Accounts/getlist",
        GET_ACCOUNT_DROPDOWN_LIST: "v1/Accounts/getlistdropdown",
        GET_BY_PRIMARY_KEY_ACCOUNT: "v1/Accounts/getbyprimarykey",
    },

    CONTACTS: {
        GET_CONTACTS_LIST: "v1/Contacts/getlist",
        DELETE_CONTACT: "v1/Contacts/delete",
        SAVE_CONTACT: "v1/Contacts/save",
        GET_BY_PRIMARY_KEY_CONTACT: "v1/Contacts/getbyprimarykey",
    },

    EMAIL_ACCOUNT: {
        GET_LIST: "v1/EmailAccounts/getlist",
        GET_BY_PRIMARY_KEY: "v1/EmailAccounts/getbyprimarykey",
        SAVE: "v1/EmailAccounts/save",
        DELETE: "v1/EmailAccounts/delete",
    },

    EMAIL_TEMPLATE: {
        GET_LIST: "v1/EmailTemplates/getlist",
        GET_BY_PRIMARY_KEY: "v1/EmailTemplates/getbyprimarykey",
        SAVE: "v1/EmailTemplates/save",
        GET_ACCOUNT_LIST: "v1/EmailTemplates/getemailaccountslist",
    },

    MODULE: {
        GET_MODULE_LIST: "v1/Module/getmoduleslist",
        GET_MODULE_WISE_PROPERTY_LIST: "v1/Module/getmoduleswiseproperylist",
    },

    PROPERTY: {
        GET_LIST: "v1/Property/getlist",
        SAVE: "v1/Property/save",
        GET_ALL_DETAILS_BY_ID: "v1/Property/getalldetailsbyid",
        DELETE: "v1/Property/delete",
        GET_PROPERTY_WISE_MODULE_LIST: "v1/Property/getpropertywisemoduleslist",
        GET_BY_PRIMARY_KEY: "v1/Property/getbyprimarykey",
        GETLISTFORWIDGETPURCHASE: "v1/Property/getlistforwidgetpurchase",
        GETLISTFORSNAPSHOTPURCHASE: "v1/Property/getlistforsnapshotpurchase",

        GETWIDGETWISEPROPERTYLIST: "v1/Property/getwidgetwisepropertylist",
        GETSNAPSHOTWISEPROPERTYLIST: "v1/Property/getsnapshotwisepropertylist",
    },

    PROPERTY_CHAT: {
        SAVE: "v1/PropertyChat/save",
        GET_LIST: "v1/PropertyChat/getlist",
        GET_UNREAD_COUNT: "v1/PropertyChat/getunreadcount",
        MARK_AS_READ: "v1/PropertyChat/markasread",
        RMCHATAPI: "https://rmcopilotapi.hotelswitchboard.com/api/v1/chat/structured-chat"
    },

    PORTFOLIO: {
        GET_LIST: "v1/Portfolio/getlist",
        SAVE: "v1/Portfolio/save",
        DELETE: "v1/Portfolio/delete",
        GET_ALL_DETAILS_BY_ID: "v1/Portfolio/getalldetailsbyid",
    },

    ROLE: {
        GET_LIST: "v1/Role/getlist",
        SAVE: "v1/Role/save",
        DELETE: "v1/Role/delete",
        GET_ALL_DETAILS_BY_ID: "v1/Role/getalldetailsbyid",
        GET_LIST_BY_MODULE: "v1/Role/getlistbymodule",
    },

    RIGHTS: {
        GET_LIST: "v1/Rights/getlist",
        GETSNAPSHOTLIST: "v1/Rights/getsnapshotlist",
    },

    USER: {
        GET_LIST: "v1/User/getlist",
        SAVE: "v1/User/save",
        GET_ALL_DETAILS_BY_ID: "v1/User/getalldetailsbyid",
        DELETE: "v1/User/delete",
        USER_PROFILE_UPDATE: "v1/User/userprofileupdate",
        GET_LIST_BY_MODULE: "v1/User/getlistbymodule",
        SALES_GROUP_USER_PROPERTY: "v1/SalesGroupUserProperty/getlist",
        SAVE_SALES_USER_PROPERTY: "v1/SalesGroupUserProperty/save",
        INVITEUSER: "v1/User/inviteuser",
        TOWFAEMAILVERIFICATION: "v1/User/towfaemailverification",
        TOWFAEMAILOTPVERIFICATION: "v1/User/towfaemailotpverification",
        TOWFAAPPSETUP: "v1/User/towfaappsetup",
        TOWFAAPPVERIFICATION: "v1/User/towfaappverification",
        REMOVETWOFA: "v1/User/removetwofa",
        VERIFYREMOVETWOFA: "v1/User/verifyremovetwofa",
    },

    USER_ROLE_PROPERTY: {
        SAVE: "v1/UserRoleProperties/save",
        DELETE: "v1/UserRoleProperties/delete",
        GET_LIST_BY_PROPERTY_AND_MODULE:
            "v1/UserRoleProperties/getlistbymoduleandpropertyparamodel",
        GET_LIST_BY_MODULE_AND_USER: "v1/UserRoleProperties/getlistbymoduleanduser",
        GET_USER_LIST_BY_MODULE_MULTI_PROPERTY:
            "v1/UserRoleProperties/getlistbymoduleandmultiplepropertyparamodel",
    },

    EMPLOYEE: {
        GET_LIST: "v1/Employee/getlist",
        SAVE: "v1/Employee/save",
        GET_BY_PRIMARY_KEY: "v1/Employee/getbyprimarykey",
        DELETE: "v1/Employee/delete",
    },

    NOTIFICATION: {
        GET_LIST: "v1/Notification/getlist",
        GET_INSIGHT_LIST: "v1/Notification/getinsightslist",
        GET_NOTIFICATION_READ_COUNT: "v1/Notification/getnotificationunreadcount",
        UPDATE_VIEW_BY: "v1/Notification/updateviewby",
    },
    ACTIONLOG: {
        GET_LIST: "v1/ActionLog/getlist",
        GET_BY_PRIMARY_KEY: "v1/ActionLog/getbyprimarykey",
        SAVE: "v1/ActionLog/save",
        SAVEPAGETRACKING: "v1/ActionLog/savepagetracking",
    },

    RATESHOPPAYMENT: {
        RATESHOPPAYMENTKPI: "v1/RateshopPayment/rateshoppaymentkpi",
        DAILYREFRESHUSAGE: "v1/RateshopPayment/dailyrefreshusage",
        LEDGER: "v1/RateshopPayment/ledger",
    },

    LOG_IN_LOGS: {
        GET_LIST: "v1/LoginLog/getlist",
    },

    REVENUE_PORTFOLIO: {
        GET_LIST: "v1/Portfolio/getlist",
    },

    REVENUE_PROPERTY: {
        GET_LIST: "v1/Property/getlist",
    },

    REVENUE_RMS_PROPERTY: {
        GET_BY_PROPERTY_ID: "v1/RMSProperty/getbypropertyid",
        SAVE: "v1/RMSProperty/save",
        CM_MINMAXRATES: "v1/RMSProperty/cm_minmaxrates",
        CM_JUMP: "v1/RMSProperty/cm_jump",
        CM_SAVE: "v1/RMSProperty/save_cm",
        CM_HNF: "v1/RMSProperty/cm_hnfdata",
        CM_SAVE_HNF: "v1/RMSProperty/save_cm_hnfdata",
    },

    REVENUE_RATE_SHOP_CONFIG: {
        GET_BY_PROPERTY_ID: "v1/RateshopConfig/getbypropertyid",
        SAVE: "v1/RateshopConfig/save",
        SAVE_DEFAULT: "v1/RateshopConfig/savedefault",
        RATE_METRICS_HOTEL_SEARCH: "v1/RateshopConfig/ratemetricshotelsearch",
        RATE_METRICS_CREATE_RATESHOP_REQUEST: "v1/RateshopConfig/ratemetricscreaterateshoprequest",
        GET_SOURCES_LIST: "v1/RateshopConfig/ratemetricsgetsourceslist",
        ADD_SOURCE_MAP: "v1/RateshopConfig/ratemetricsaddsourcemap",
        HOTEL_MAP_REQUEST: "v1/RateshopConfig/ratemetricshotelmaprequest",
        RATE_METRICS_CREATE_ONDEMAND_RATE_SHOP_REQUEST: "v1/RateshopConfig/ratemetricscreateondemandrateshoprequest",
    },

    REVENUE_PROPERTY_COMPETITER: {
        GET_LIST: "v1/PropertyCompetiters/getlist",
        SAVE: "v1/PropertyCompetiters/save",
        GET_BY_PRIMARY_KEY: "v1/PropertyCompetiters/getbyprimarykey",
        DELETE: "v1/PropertyCompetiters/delete",
        BULK_SAVE: "v1/PropertyCompetiters/bulksaveweightageself",
        UPDATE_ALL_CHANNEL_JSON: "v1/PropertyCompetiters/updateallchanneljson",
    },

    REVENUE_ROOM_TYPE: {
        GET_LIST: "v1/RoomType/getlist",
        SAVE: "v1/RoomType/save",
        GET_BY_PRIMARY_KEY: "v1/RoomType/getbyprimarykey",
        DELETE: "v1/RoomType/delete",
    },

    REVENUE_SEASON: {
        GET_LIST: "v1/Season/getlist",
        GET_BY_PRIMARY_KEY: "v1/Season/getbyprimarykey",
        SAVE: "v1/Season/save",
        DELETE: "v1/Season/delete",
    },

    REVENUE_RATE_PLAN: {
        GET_LIST: "v1/RatePlan/getlist",
        SAVE: "v1/RatePlan/save",
        GET_BY_PRIMARY_KEY: "v1/RatePlan/getbyprimarykey",
        DELETE: "v1/RatePlan/delete",
        FILE_UPLOAD: "v1/RatePlan/readrateplanfile",
        IMPORT_LIST: "v1/RatePlan/exportlist",
        GET_UNMAPPEDRATE_PLANCODE_DATA: "v1/RatePlan/getunmappedrateplancodedata",
    },

    REVENUE_ROOM_TYPE_CONFIG: {
        GET_LIST: "v1/RoomTypeBarConfig/getlist",
        SAVE: "v1/RoomTypeBarConfig/save",
        GET_BY_PRIMARY_KEY: "v1/RoomTypeBarConfig/getbyprimarykey",
        DELETE: "v1/RoomTypeBarConfig/delete",
        DELETEMULTI: "v1/RoomTypeBarConfig/deletemulti",
    },
    // REVENUE_ROOM_TYPE_CONFIG: {
    //   GET_LIST: "v1/RoomTypeBarConfig/getlist",
    //   SAVE: "v1/RoomTypeBarConfig/save",
    //   GET_BY_PRIMARY_KEY: "v1/RoomTypeBarConfig/getbyprimarykey",
    //   DELETE: "v1/RoomTypeBarConfig/delete",
    //   DELETEMULTI: "v1/RoomTypeBarConfig/deletemulti",
    // },

    REVENUE_BAR_CONFIG: {
        GET_LIST: "v1/BarConfig/getlist",
        SAVE: "v1/BarConfig/save",
        GET_BY_PRIMARY_KEY: "v1/BarConfig/getbyprimarykey",
        DELETE: "v1/BarConfig/delete",
        DELETEMULTI: "v1/BarConfig/deletemulti",
    },
    // REVENUE_BAR_CONFIG: {
    //   GET_LIST: "v1/BarConfig/getlist",
    //   SAVE: "v1/BarConfig/save",
    //   GET_BY_PRIMARY_KEY: "v1/BarConfig/getbyprimarykey",
    //   DELETE: "v1/BarConfig/delete",
    //   DELETEMULTI: "v1/BarConfig/deletemulti",
    // },

    REVENUE_BUDGET: {
        GET_LIST: "v1/Budget/getlist",
        SAVE: "v1/Budget/save",
        DELETE: "v1/Budget/delete",
        SAVEBYDATE: "v1/Budget/savebydate",
        SAVEBYDATEWITHTOTAL: "v1/Budget/savebydatewithtotal",
    },

    REVENUE_FORE_CAST: {
        GET_LIST: "v1/Forecast/getlist",
        SAVE: "v1/Forecast/saveuserforcast",
        DELETE: "v1/Forecast/delete",
        SAVEBYDATE: "v1/Forecast/savebydate",
        SAVEBYDATEWITHTOTAL: "v1/Forecast/savebydatewithtotal",
    },

    REVENUE_RATE_SHOP_COMPARISON: {
        GET_LIST: "v1/RateComparison/getlist",
        GET_BY_PRIMARY_KEY: "v1/RateComparison/getbyprimarykey",
        SAVE: "v1/RateComparison/save",
        DELETE: "v1/RateComparison/delete",
    },

    WIDGET: {
        GET_LIST: "v1/Widget/getlist",
        GET_BY_PRIMARY_KEY: "v1/Widget/getbyprimarykey",
        SAVE_GROUP_DATA: "widget/insert_group_data",
        GET_WIDGET_BY_PROPERTY: "v1/widget/getlistbyproperty",
    },

    SNAPSHOT: {
        GET_LIST: "v1/Snapshot/getlist",
        GET_LIST_GROUP_BY_TITLE: "v1/Snapshot/getlistgroupbytitle",
        GET_BY_PRIMARY_KEY: "v1/Snapshot/getbyprimarykey",
        SAVE: "v1/Snapshot/save",
        DELETE: "v1/Snapshot/delete",
        STATUS_CHANGE: "v1/Snapshot/statuschange",
        GET_LIST_FOR_MENU: "v1/Snapshot/getlistformenu",
        SHOW_IN_MENU_CHANGE: "v1/Snapshot/isshowinmenuchange",
        SNAPSHOT_MAIL: "v1/Snapshot/snapshotmail",
        EMAIL_SCHEDULE_SAVE: "v1/Snapshot/snapshotemailschedulesave",
        COPY_SNAPSHOT: "v1/Snapshot/copysnapshort",
        EXPORT_WIDGET_WISE_EXCEL: "v1/Snapshot/exportexcelwidgetwise",
        GET_SNAPSHOT_COUNT: "snapshot/count",
        GET_CURRENT_DATE_RESERVATION: "/snapshot/current_date_reservation",
        BOOKING_CURVE_CUMULATIVE_OTB: "snapshot/booking_curve_cumulative_otb",
        SANAPSHOTREVPAKMAIL: "v1/Snapshot/sanapshotrevpakmail",

        GETMAILSCHEDULEMENULIST: "v1/Snapshot/GetMailScheduleMenuList",
    },

    SNAPSHOTMAILSETUP: {
        SAVE: "v1/Snapshot/sanapshotmailsetupsave",
        DELETE: "v1/Snapshot/sanapshotmailsetupdelete",
        REFRESH: "v1/Snapshot/sanapshotmailsetuprefresh",
        GETBYID: "v1/Snapshot/sanapshotmailsetupgetbyprimarykey",
        GETBYSNAPSHOTID: "v1/Snapshot/sanapshotmailsetupgetbysnapshotid",
        GETLIST: "v1/Snapshot/getsnapshotmailsetupscheduledbyproperty",
        ISPAUSE: "v1/Snapshot/sanapshotmailsetupispause",
    },

    USER_SNAPSHOT: {
        GET_LIST: "v1/UserSnapshot/getlist",
        SAVE: "v1/UserSnapshot/save",
        DELETE: "v1/UserSnapshot/delete",
    },

    ANNUAL_SUMMARY: {
        ON_THE_BOOK: "snapshot/snp_annsmry_on_the_book",

        NET_STLY: "snapshot/snp_annsmry_net_stly",
        TOTAL_STLY: "snapshot/snp_annsmry_total_stly",

        OTB_VARIANCE: "revevolve/snp_otb_variance",
        TOTAL_LY: "snapshot/snp_annsmry_total_ly",
        BUDGET: "snapshot/snp_annsmry_budget",
        CHART: "chart/snp_annsmry_chart",
        GET_VARIANCE: "snapshot/snp_annual_summary_variance",
        GET_VARIANCE_DATEWISE: "snapshot/snp_annual_summary_variance_datewise",
        GET_BUDGET_VARIANCE: "snapshot/snp_annual_summary_variance_budget",
        GET_SYSTEM_FORECAST_VARIANCE:
            "snapshot/snp_annual_summary_variance_forecast",
        GET_USER_FORECAST_VARIANCE:
            "snapshot/snp_annual_summary_variance_user_forecast",
        GET_RMS_FORECAST_VARIANCE:
            "snapshot/snp_annual_summary_variance_rms_forecast",
        SEASONALITY_ANALYSIS: "snapshot/annsmry_on_the_book_ByYear",
        CURRENT_DATE_RESERVATION_DETAIL:
            "snapshot/current_date_reservation_details",
        GET_NOVA_FORECAST_VARIANCE:
            "snapshot/snp_annual_summary_variance_nova_forecast",

        TOTAL_LY_DATEWISE: "snapshot/snp_annsmry_total_ly_datewise",
        NET_STLY_DATEWISE: "snapshot/snp_annsmry_net_stly_datewise",
        NET_TOTAL_STLY_DATEWISE: "snapshot/snp_annsmry_total_stly_datewise",
    },

    PICK_UP: {
        ONE_DAY: "snapshot/snp_pickup_one_day",
        ONE_DAY_FORECAST_CHANGE: "snapshot/snp_pickup_one_day_forcast_change",
        SEVEN_DAY: "snapshot/snp_pickup_seven_day",
        SEVEN_DAY_FORECAST_CHANGE: "snapshot/snp_pickup_seven_day_forcast_change",
        ONE_DAY_CHART: "chart/snp_pickup_one_day_chart",
        THREE_DAY_CHART: "chart/snp_pickup_three_day_chart",
        SEVEN_DAY_CHART: "chart/snp_pickup_seven_day_chart",
        DYNAMIC_PICKUP: "widget/snp_dynamic_pickup",
        SEVEN_DAY_BOOKING_RESERVATION: "widget/seven_day_booking_rooms",
        SEVEN_DAY_BOOKING_EXPECTED: "widget/seven_day_booking_expected",
        SEVEN_DAY_BOOKING_PACE: "widget/seven_day_booking_pace",
        SEVEN_WEEK_BOOKING_PACE: "widget/seven_week_booking_pace",
        THIRTY_DAY_PICKUP: "widget/dbd_30_days_pickup",
        FORECAST_USING_90_DAY_PICKUP: "widget/snp_dynamic_pickup_forecast",
        DYNAMIC_FORECAST_USING_90_DAY_PICKUP: "chart/forecast_using_90days_pickup",
        DYNAMIC_FORECAST_USING_90_DAY_PICKUP_NEW:
            "chart/forecast_using_90days_pickup_new",

        ONE_DAY_PICKUP_THRESHOLD: "snapshot/one_day_pickup_threshold",
        SEVEN_DAY_PICKUP_THRESHOLD: "snapshot/seven_day_pickup_threshold",
        FOURTEEN_DAY_PICKUP_THRESHOLD: "snapshot/fourteen_day_pickup_threshold",
        THRESHOLD_ON_THE_BOOK: "snapshot/threshold_on_the_book",
        CUSTOM_PICKUP_THRESHOLD: "snapshot/custom_pickup_threshold",

        THREE_DAY: "snapshot/snp_pickup_three_day",
        THREE_DAY_FORECAST_CHANGE: "snapshot/snp_pickup_three_day_forcast_change",
    },

    TRANSIENT_GROUP: {
        GROUP: "snapshot/snp_tg_group",
        GROUP_LAST_YEAR: "snapshot/snp_tg_group_last_year",
        TRANSIENT: "snapshot/snp_tg_transient",
        TRANSIENT_LAST_YEAR: "snapshot/snp_tg_transient_last_year",
        CHART: "chart/snp_tg_chart",
    },
    DYNAMIC_PRICING: {
        SNP_PRICING_GRID: "revevolve/snp_pricing_grid",
        SNP_PRICING_GRID_DETAIL: "revevolve/snp_pricing_grid_detail",
        SNP_RECAP_REPORT: "revevolve/recap_report",
        SNP_PORTFOLIO_RECAP_REPORT: "revevolve/portfolio_recap_report",
    },

    DAILY_SUMMARY: {
        ORG: "snapshot/snp_ds_otb",
        RECOMMENDED_RATE: "widget/dbd_recommended_rate",
        PICKUP_FROM: "snapshot/snp_ds_pickup",
        RATESHOP_LIST: "rateShop/rate_shop_list_asofdate",
        SINGLE_DAY_GROUP_SUMMARY: "widget/Single_day_group_summary",
        MULTIPLE_DAY_GROUP_SUMMARY: "snapshot/snp_group_detail",
        SINGLE_DAYBYDAY_SEGMENT_WISE_FORECAST: "snapshot/dbd_segment_wise_forecast",
        SAVE_UPDATE: "snapshot/snp_notes_update",
        PRICING_FORECAST: "widget/dbd_forecast",
        BAR_BASED_STATS: "snapshot/snp_bar_based_stats",
        SINGLE_DATE_SUMMARY_DAY_WISE: "snapshot/snp_ds_single_date_summary_daywise",
        STRATEGY_BY_RESERVATION_PICKUP: "snapshot/dbd_pickup",
        STRATEGY_BY_RESERVATION_PICKUP_SINGLE_DATE_SUMMARY:
            "snapshot/dbd_pickup_single_date_summary",
        OTB_RESERVATION: "snapshot/snp_ds_otb_res",
        FLAG_MECHANISM: "chart/flag_mechanism",
        STLY_LY_COMSET_RATES: "widget/dbd_rates",
        STLY_LY_COMSET_RATES_DATEWISE: "widget/dbd_rates_datewise",
        PAST_RATESHOP_LIST: "rateShop/past_rate_shop_list_asofdate ",
    },
    //DAILY_SUMMARY: {
    //    ORG: "snapshot/snp_ds_otb",
    //    PICKUP_FROM: "snapshot/snp_ds_pickup",
    //    RATESHOP_LIST: "rateShop/rate_shop_list_asofdate",
    //    SINGLE_DAY_GROUP_SUMMARY: "widget/Single_day_group_summary",
    //    SAVE_UPDATE: "snapshot/snp_notes_update",
    //    PRICING_FORECAST: "widget/dbd_forecast",
    //    BAR_BASED_STATS: "snapshot/snp_bar_based_stats",
    //},

    RESERVATION_ACTIVITY: "snapshot/snp_ra_reservation_activity",

    LOS: {
        LOS_DAY_OF_WEEK: "widget/los_day_of_week_chart",
    },

    HEAT_MAP: "snapshot/snp_hm_heatmap",
    HEAT_MAP_NEW: "snapshot/new_snp_hm_heatmap",

    HEATMAP_CANCELLATION: "snapshot/heatmap_cancellation",

    WIDGET_BUDGET: {
        WIDGET_BUDGET: "chart/widget_occ_rms_adr",
    },

    FORECAST: {
        SPIDER_FORECAST: "snapshot/snp_fc_spider",
        RMS_FORECAST: "snapshot/snp_fc_rms",
        USER_FORECAST: "snapshot/snp_fc_user",
        NOVA_FORECAST: "snapshot/snp_fc_nova",
        CHART: "chart/snp_fc_chart",
        EMA_FORECAST_V2: "widget/snp_fc_ema_v2",
        EMA_FORECAST_V3: "widget/snp_fc_ema_v3",
        FORECAST_VS_OTB_CHART: "/rateShop/dbd_room_forecast_vs_otb",
        PAST_FORECAST_CHART: "chart/past_forecast_chart",
    },

    CHOICE_RES: {
        CHOICE_RES: "widget/choice_res",
    },

    MST_RESERVATION: {
        MST_RESERVATION: "widget/mst_reservation",
    },

    DAILY_DATA_TRANSACTION: {
        DAILY_DATA_TRANSACTION: "widget/dailydata_transaction",
    },

    AS_OF_DATE: {
        AS_OF_DATE: "widget/last_data_refresh",
        ALL_LAST_REFRESH_DATE: "crm/lastrefreshdates",
    },

    BOOKING_PACE: {
        CHART: "snapshot/snp_bp_bookingpace",
        CANCELLATION_CHART: "chart/booking_pace_comparison",
        COMPARISON_CHART: "chart/booking_pace_comparison_chart",
        BOOKING_PACE: "chart/booking_pace",
        NEW_BOOKING_PACE: "chart/new_booking_pace",
        NEW_BOOKING_PACE_DATEWISE: "chart/new_booking_pace_datewise",
    },

    MARKET_SEGMENT: {
        SWOT_ANALYSIS: "chart/swot_analysis",
        CHART: "chart/marketSegment",
        DAY_BY_DAY_PICKUP: "widget/dbd_ms_pickup",
        DAY_BY_DAY_STLY: "widget/dbd_ms_stly",
        DAY_BY_DAY_STLY_DATEWISE: "widget/dbd_ms_stly_datewise",
        ROOM_TYPE_STLY: "widget/dbd_room_type_stly",
        ROOM_TYPE_STLY_DATEWISE: "widget/dbd_room_type_stly_datewise",
        ROOM_TYPE_PICKUP: "widget/dbd_room_type_pickup",
        GROUP: "widget/dbd_group",
        SINGLE_DATE_ROOM_TYPE_SUMMARY: "widget/dbd_room_type_single_date_summary",
        LENGTH_OF_STAY_PICKUP: "widget/dbd_los_type_pickup",
        LENGTH_OF_STAY_STLY: "widget/dbd_los_type_stly",
        LENGTH_OF_STAY_STLY_DATEWISE: "widget/dbd_los_type_stly_datewise",
        CHANNEL_STLY: "widget/dbd_channel_stly",
        CHANNEL_STLY_DATEWISE: "widget/dbd_channel_stly_datewise",
        CHANNEL_PICKUP: "widget/dbd_channel_pickup",
        RESERVATION_ANAYLTICS_CHART: "chart/marketsegmentwisereservation_analytic",
        /*RESERVATION_ANAYLTICS_CHART_NEW:"chart/marketsegmentwisereservation_analytic_new",*/
        RESERVATION_ANAYLTICS_CHART_NEW: "chart/new_marketsegmentwisereservation_analytic_new",
        DAY_OF_WEEK_SEGMENT_MIX: "widget/day_of_week_segment_mix",
        SNP_GROUP_NAME: "snapshot/snp_group_name",
    },

    GROUP_IQ: {
        WIDGET: "widget/dbd_group_iq",
        CHART: "widget/dbd_group_iq_chart",
    },

    REPORT: {
        MARKET_SEGMENT_PICKUP: "revevolve/snp_market_segment_pickup",
        OTB_TRANSIENT_GROUP_VARIANCE: "revevolve/snp_otb_transient_group_variance",
    },

    RNX: {
        RNX_FILTER_ONE: "rnx_snapshot/rnx_filter_one",
        RNX_MONTH_WISE_SUMMARY: "rnx_snapshot/rnx_month_wise_summary",
        RNX_DOW_WISE_SUMMARY_PER_TOTAL_DOW:
            "rnx_snapshot/rnx_dow_wise_summary_per_total_dow",
        RNX_MONTH_WISE_SUMMARY_STLY: "rnx_snapshot/rnx_month_wise_summary_stly",
        RNX_DOW_WISE_SUMMARY: "rnx_snapshot/rnx_dow_wise_summary",
        RNX_DOW_WISE_SUMMARY_STLY: "rnx_snapshot/rnx_dow_wise_summary_stly",

        RNX_DOW_WISE_AVG_LOS: "rnx_snapshot/rnx_dow_wise_avg_los",
        RNX_ARRIVAL_VS_STAY: "rnx_snapshot/rnx_dow_wise_arrival_vs_stay",
        RNX_TW_MONTH_WISE_SUMMARY: "rnx_snapshot/rnx_tw_month_wise_summary",
        RNX_LW_MONTH_WISE_SUMMARY: "rnx_snapshot/rnx_lw_month_wise_summary",
        RNX_TW_MONTH_WISE_SUMMARY_STLY:
            "rnx_snapshot/rnx_tw_month_wise_summary_stly",
        RNX_LW_MONTH_WISE_SUMMARY_STLY:
            "rnx_snapshot/rnx_lw_month_wise_summary_stly",
        RNX_TW_MONTH_WISE_SUMMARY_LY: "rnx_snapshot/rnx_tw_month_wise_summary_ly",
        RNX_DOW_WISE_CONTRIBUTION: "rnx_snapshot/rnx_dow_wise_contribution",
        RNX_CHANNEL_WISE_SUMMARY: "rnx_snapshot/rnx_channel_wise_summary",
        RNX_RATE_BAND_THIS_YEAR: "rnx_snapshot/rnx_rate_band_this_year",
        RNX_RATE_BAND_LAST_YEAR: "rnx_snapshot/rnx_rate_band_last_year",
        RNX_RATE_BAND_DOW_TY: "rnx_snapshot/rnx_rate_band_dow_ty",
        RNX_RATE_BAND_DOW_LY: "rnx_snapshot/rnx_rate_band_dow_ly",
        RNX_BOOKING_PACE: "rnx_snapshot/rnx_booking_pace",
        RNX_RATE_PACE_GRAPH: "rnx_snapshot/rnx_rate_pace_graph",
        RNX_MONTH_WISE_SUMMARY_SOTM: "rnx_snapshot/rnx_month_wise_summary_sotm",
        RNX_MONTH_WISE_SUMMARY_SOTM_STLY:
            "rnx_snapshot/rnx_month_wise_summary_sotm_stly",
        RNX_ON_THE_BOOk: "rnx_snapshot/rnx_on_the_book",
        RNX_OTB_PICKUP: "rnx_snapshot/rnx_otb_pickup",
        RNX_OTB_CHANNELS: "rnx_snapshot/rnx_otb_channels",
        RNX_OTB_MARKET_TRENDS: "rnx_snapshot/rnx_otb_market_trands",

        RNX_DS_SINGLE_DATE_SUMMARY: "rnx_snapshot/rnx_ds_single_date_summary",

        RNX_WEEKLY_BOOKING_PACE: "rnx_snapshot/rnx_weekly_booking_pace",

        RNX_CANCELLATION_ACTIVITY: "rnx_snapshot/rnx_cancellation_activity",

        RNX_MONTHLY_BOOKING_PACE: "rnx_snapshot/rnx_monthly_booking_pace",

        RNX_CHANNELS: "rnx_snapshot/rnx_channels",
        RNX_CHANNELS_PICKUP: "rnx_snapshot/rnx_channels_pickup",
        RNX_CANCELLATION_HEATMAP: "rnx_snapshot/rnx_cancellation_heatmap",
        RNX_DS_SINGLE_WEEK_SUMMARY: "rnx_snapshot/rnx_ds_single_week_summary",
        CM_RNX_MONTHLY_BOOKING_DRILLDOWN: "rnx_snapshot/rnx_monthly_booking_drilldown",
        RNX_SNP_RES_ARRIVALS: "snapshot/snp_res_arrivals",
    },

    WIDGET_MODULE: {
        CHOICE_OCCUPANCY: "widget/choice_occ",
        HOTEL_KEY_RESERVATION: "widget/hotel_key_res",
        HOTEL_KEY_OCCUPANCY_SNAPSHOT: "widget/hotel_key_occ",
        BEST_WESTERN_GUEST_NAME: "widget/bw_guest_name",
        BEST_WESTERN_RESERVATION_AGENT: "widget/bw_res_agent",
        BEST_WESTERN_RESERVATION_FORECAST: "widget/bw_res_forecast",
        BEST_WESTERN_ROOM_MAINTAINCE: "widget/bw_room_maintenance_ooo",
        EVENT: "event/rev_event_list",
        SINGLE_DATE_SUMMARY: "snapshot/snp_ds_single_date_summary",
        SNP_MONTHLY_CANCELLATION_DRILLDOWN: "snapshot/snp_monthly_cancellation_drilldown",
        PMS_SNP_MONTHLY_BOOKING_SUMMARY: "snapshot/snp_monthly_booking_summary",
        SINGLE_DATE_SUMMARY_AVGLEADTIME: "snapshot/snp_ds_single_date_summary_avgleadtime",
        SINGLE_DATE_SUMMARY_DATEWISE: "snapshot/snp_ds_single_date_summary_datewise",
        CHOICE_CANCELATION_SUMMARY: "widget/choice_cancellation",
        ADR_VS_RATE_CHART: "chart/adr_vs_rate_chart",
        WIDGET_PICKUP: "widget/widget_pickup",
        CHOICE_BUSINESS_ON_THE_BOOK: "widget/choice_busi_on_books",
        CHOICE_REVENUE: "widget/choice_revenue",
        RMS_SINGLE_DATE_SUMMARY: "widget/dbd_ms_single_date_summary",
        REV_YOY_CHART: "chart/rev_yoy_month_chart",
        EVENT_STRETEGY: "event/event_strategy",
        CANCELLATION_SINGLE_DATE_SUMMARY:
            "snapshot/snp_cancellation_single_date_summary",
        UPDATE_WIDGET_SUMMARY_FLAG: "v1/Widget/updatewidgetgeneratesummaryflag",
        UPDATE_WIDGET_BULLETIN_FLAG: "v1/Widget/updatewidgetgeneratebulletinflag",
    },

    EVENTS: {
        REVENUE_DASHBOARD_CALENDAR_LIST:
            "v1/Events/getrevenuedashboardcalendardatalist",
        GET_LIST: "v1/Events/getlist",
        DELETE: "v1/Events/delete",
        SAVE: "v1/Events/save",
        GET_BY_PRIMARY_KEY: "v1/Events/getbyprimarykey",
        IMPORT: "v1/Events/import",
        GET_ALL_EVENT_SOURCE_ID: "v1/Events/getalleventsourceid",
        GET_EVENT_BY_SINGLE_DATE: "v1/Events/getlistbydate",
        EVENT_RATEIQ: "v1/Events/eventrateiqratevaluechange",
        DELETE_REVENUE_DASHBOARD_EVENT: "v1/Events/deletedashboardcalendardata",
        DATE_WISE_BOOKING: "event/eventdate_wise_booking",

        FILE_UPLOAD: "v1/Events/readeventfile",
        IMPORT_LIST: "v1/Events/exportlist",
    },

    RATESHOP: {
        RATESHOP_LIST: "rateShop/rate_shop_list",
        COMPETITOR_LIST: "rateShop/competitor_list",
        HISTORY_CHART: "rateShop/dbd_rate_shop_history",
        // GET_PERITY_CHECK: "rateShop/channel_parity",  // Previously in use
        GET_PERITY_CHECK: "rateShop/new_channel_parity", // Currently in use
        GET_RATE_EVOLUTION: "rateShop/rate_evolution",
        DISPLACEMENT_RATE_SHOP_ASOFDATE: "rateShop/displacement_rate_shop_asofdate",

        NEW_RATESHOP_LIST: "rateShop/new_rateshop_list",

    },

    RATEPLAN: {
        DAY_BY_DAY_STLY: "widget/dbd_rate_plan_stly",
        DAY_BY_DAY_STLY_DATEWISE: "widget/dbd_rate_plan_stly_datewise",
        DAY_BY_DAY_PICKUP: "widget/dbd_rate_plane_pickup",
        TOP_10_CHART: "widget/top_10_rateplane",
    },

    REMINDER: {
        GET_LIST: "v1/Reminder/getlist",
        DELETE: "v1/Reminder/delete",
        SAVE: "v1/Reminder/save",
        GET_BY_PRIMARY_KEY: "v1/Reminder/getbyprimarykey",
        IMPORT: "v1/Reminder/import",
        GET_EVENT_BY_SINGLE_DATE: "v1/Reminder/getlistbydate",
    },

    CRM_PROSPECTS: {
        GET_LIST: "v1/Lead/getlist",
        GET_BY_PRIMARY_KEY_WITH_DETAILS: "v1/Lead/getbyprimarykeywithdetails",
        SAVE: "v1/Lead/save",
        DELETE: "v1/Lead/delete",
        CONVERT_TO_ACCOUNT: "v1/Lead/converttoaccount",
        LEAD_DASHBOARD_COUNT: "v1/Lead/getleaddashboardcount",
    },

    ACTIVITIES: {
        GET_LIST: "v1/Activities/getlist",
        SAVE: "v1/Activities/save",
        DELETE: "v1/Activities/delete",
        GET_BY_PRIMARY_KEY: "v1/Activities/getbyprimarykey",
        GET_BY_PRIMARY_KEY_WITH_DETAILS: "v1/Activities/getbyprimarykeywithdetails",
        GET_ACTIVITY_DASHBOARD_COUNT: "v1/Activities/getactivitydashboardcount",
    },

    SEGMENT_DRILLDOWN: {
        FILTER: "widget/dbd_drilldown_filter",
        GET_MARKETSEGMENT: "widget/dbd_drilldown_marketsegment",
        GET_MARKETSEGMENT_DATEWISE: "widget/dbd_drilldown_marketsegment_datewise",
        GET_MONTHLY_OCC_SUMMARY: "widget/monthly_occ_summary",
        GET_ROOMTYPE: "widget/dbd_drilldown_roomtype",
        GET_ROOMTYPE_DATEWISE: "widget/dbd_drilldown_roomtype_datewise",
        GET_RATECODE: "widget/dbd_drilldown_ratecode",
        GET_ROOMTYPE_MARKETSEGMENT: "widget/dbd_roomtype_marketsegment",
        GET_ROOMTYPE_RATECODE: "widget/dbd_roomtype_ratecode",
        GET_COMPANY: "widget/dbd_drilldown_company",
        GET_ROOMTYPE_COMPANY: "widget/dbd_roomtype_company",
        GET_GUEST: "widget/dbd_drilldown_guestName",
        GET_ROOMTYPE_GUEST: "widget/dbd_roomtype_guestname",
    },

    REV_PAK_90_DAY_OUTLOOK: {
        GET_LY: "widget/dbd_revpak_90_days_outlook_LY",
        GET_LY_DATEWISE: "widget/dbd_revpak_90_days_outlook_LY_datewise",
        GET_NET_STLY: "widget/dbd_revpak_90_days_outlook_LY",
        GET_NET_STLY_DATEWISE: "widget/dbd_revpak_90_days_outlook_LY_datewise",
        GET_MARKETSEGMENT: "widget/dbd_revpak_90_days_outlook_ms",
        GET_MARKETSEGMENT_DATEWISE: "widget/dbd_revpak_90_days_outlook_ms_datewise",
        GET_RATECODE: "widget/dbd_revpak_90_days_outlook_ratecode",
        GET_COMPANY: "widget/dbd_revpak_90_days_outlook_company",
        GET_GUEST: "widget/dbd_revpak_90_days_outlook_guestName",
        GET_OUTLOOK_TOTAL: "widget/dbd_revpak_90_days_outlook_Total",
    },

    LAST_YEAR_AND_FORECAST: {
        LAST_YEAR_AND_FORECAST: "widget/dbd_last_year_forecast",
        GET_BUDGET_DATA: "widget/dbd_last_year_forecast_budget",
    },

    CANCELLATION: {
        GET_ANN_SUMMARY: "snapshot/snp_annsmry_cancellation",
        CANCELLATION_PACE: "snapshot/snp_cancellation_pace",
        GET_CY_CANCELLATION_BOOKING_REV_LOSS:
            "widget/dbd_Cancelled_Booking_Revenue_Loss_CY",
        GET_LY_CANCELLATION_BOOKING_REV_LOSS:
            "widget/dbd_Cancelled_Booking_Revenue_Loss_LY",
        GET_STLY_CANCELLATION_BOOKING_REV_LOSS:
            "widget/dbd_Cancelled_Booking_Revenue_Loss_STLY",
        MONTHLY_CANCELLATION_PACE: "widget/dbd_monthly_cancellation_pace",
        GET_CANCELLATION_DAY_BY_DAY: "widget/dbd_cancellation_day_by_day",
        GET_CANCELLATION_BOOKING_REV_LOSS:
            "widget/dbd_Cancelled_Booking_Revenue_Loss",
    },

    SNAPSHOT_ACCOUNT_WIDGET: {
        GET_FILTER: "widget/dbd_Accounts_filter",
        GET_RATECODE: "widget/dbd_Accounts_ratecode",
        GET_RATECODE_DESCRIPTION: "widget/dbd_Accounts_ratecodedescript",
        GET_COMPANY: "widget/dbd_Accounts_company",
        GET_MARKET_SEGMENT: "widget/dbd_Accounts_marketsegment",
        GET_CHANNEL: "widget/dbd_Accounts_channel",

        GET_LY_RATECODE: "widget/dbd_ly_accounts_ratecode",
        GET_LY_RATECODE_DESCRIPTION: "widget/dbd_ly_accounts_ratecodedescript",
        GET_LY_COMPANY: "widget/dbd_ly_accounts_company",
        GET_LY_MARKET_SEGMENT: "widget/dbd_ly_accounts_marketsegment",
        GET_LY_CHANNEL: "widget/dbd_ly_accounts_channel",
    },

    REV_PAK_90_DAY_SEGMENT: {
        GET_SEGMENT: "widget/dbd_revpak_90_days_segments",
    },

    TOP_50_BY_REVENUE: {
        GET_TOP_50_BY_REVENUE: "widget/dbd_top_50_revenue",
    },

    RATEIQ: {
        GET_LIST: "widget/dbd_rateshop_iq",
        FORECAST_LIST: "widget/dbd_ml_room",
        GET_CHART: "rateShop/dbd_rate_shop_history_ml_rate",
        GET_RATE_GAIN_DATA_FROM_THIRD_PARTY: "rateShop/get_rates_from_rategain",
        NEW_GET_CHART: "rateShop/new_dbd_rate_shop_history_ml_rate",

    },

    WIDGET_NOTE: {
        SAVE: "v1/WidgetNote/save",
        GET_LIST: "v1/WidgetNote/getlist",
        DELETE: "v1/WidgetNote/delete",
        GET_LIST_PAGINATION: "v1/WidgetNote/getlistpagination",
        GET_BY_DATA_LIST: "v1/WidgetNote/getbydatalist",
        SAVE_BY_ASSOCIATION: "v1/WidgetNote/savebyassociation",
        GET_BY_ASSOCIATION: "v1/WidgetNote/getlistassociation",
    },

    TODO: {
        GET_LIST: "v1/Todo/getlist",
        SAVE: "v1/Todo/save",
        DELETE: "v1/Todo/delete",
        UPDATE_TODO: "v1/Todo/statuschange",
        GET_BY_PRIMARY_KEY: "v1/Todo/getdetailsbyprimarykey",
    },

    RATESHOP_SOLDOUT: {
        GET_LIST: "v1/RateShopSoldoutDetails/getlist",
        SAVE: "v1/RateShopSoldoutDetails/save",
        DELETE: "v1/RateShopSoldoutDetails/delete",
    },

    EMAIL_WIDGET: {
        DAILY_DATA_WIDGET_ONE: "widget/dbd_Daily_Data_Widget1",
        DAILY_DATA_WIDGET_TWO: "widget/dbd_Daily_Data_Widget2",
        DAILY_DATA_WIDGET_THREE: "widget/dbd_Daily_Data_Widget3",
        WEEKLY_DATA_WIDGET_ONE: "widget/dbd_Weekly_Data_Widget1",
        WEEKLY_DATA_WIDGET_TWO: "widget/dbd_Weekly_Data_Widget2",
        WEEKLY_DATA_WIDGET_THREE: "widget/dbd_Weekly_Data_Widget3",
        WEEKLY_MS: "widget/dbd_Weekly_Data_ms",
        WEEKLY_MS_DATEWISE: "widget/dbd_Weekly_Data_ms_datewise",
        WEEKLY_RATECODE: "widget/dbd_Weekly_Data_ratecode",
        WEEKLY_COMPANY: "widget/dbd_Weekly_Data_company",
        WEEKLY_GUESTNAME: "widget/dbd_Weekly_Data_guestName",
        MONTHLY_MS: "widget/dbd_Monthly_Data_ms",
        MONTHLY_RATECODE: "widget/dbd_Monthly_Data_ratecode",
        MONTHLY_COMPANY: "widget/dbd_Monthly_Data_company",
        MONTHLY_GUESTNAME: "widget/dbd_Monthly_Data_guestName",
    },
    CRM_REPORT: {
        DASHBOARD_WEEKLY_REPORT: "v1/Report/DashBoardWeeklyReport",
        ACTIVITIES_REPORT: "v1/Report/ActivitiesReportList",
        ACTIVITY_GOAL_REPORT: "v1/Report/ActivityGoalsReportList",
        LOST_BUSSINESS_GRID_REPORT: "v1/Report/LostBusinessGridReportList",
        MONTHLY_ROLL_UP_REPORT: "v1/Report/MonthlyRollupReportList",
        TRACE_REPORT: "v1/Report/TraceReportList",
        SALES_FUNNEL_GRID_REPORT: "v1/Report/SalesFunnnelGridReportList",
        MEETING_AND_CATERING_BY_DATE_REPORT:
            "v1/Report/MeetingCateringByDateReportList",
        RFP_GRID_REPORT: "v1/Report/RFPGridReportList",
        LNR_GRID_REPORT: "v1/Report/LNRGridReportList",
        GROUP_GRID_REPORT: "v1/Report/GroupGridReportList",
        MEETING_CATERING_GRID_REPORT: "v1/Report/MeetingCateringGridReportList",
        MARKETING_PLAN_REPORT: "v1/Report/MarketingPlanReport",
        OPPORTUNITY_BY_SOURCE_REPORT: "v1/Report/OpportunityBySourceReportList",
        GROUP_ROOM_COUNT_REPORT: "v1/Report/GroupRoomCountReportList",
        MEETING_ROOM_BOOKED_REPORT: "v1/Report/MeetingRoomBookedReportList",
        GROUP_PACE_REPORT: "v1/Report/GroupPaceReport",
        MEETING_PACE_REPORT: "v1/Report/MeetingPaceReport",
        LEAD_REPORT: "v1/Report/LeadReport",
        WEEKLY_REPORT: "v1/Report/WeeklyReport",
    },
    STR_REPORT_REVPAK: {
        GET_RUNNING_STR_REPORT: "widget/snp_running_28_star",
        GET_WEEKLY_REPORT: "widget/snp_weekly_star",
        RUNNING_STR_SAVE: "widget/insert_and_update_running_28_star",
        WEEKLY_STR_SAVE: "widget/insert_and_update_weekly_star",
        READ_STR_ANALYSIS: "v1/STRAnalysis/readstranalysisfile",
        GET_MONTHLY_REPORT: "widget/snp_monthly_star",
    },

    SCHEDULE_REVENUE: {
        SAVE: "v1/Schedule/save",
        GET_DETAIL_BYID: "v1/Schedule/getdetailbyid",
    },

    RATEIQ_WEEKDAY: {
        GET_LIST: "v1/RateIQ_WeekDays/getlist",
        SAVE: "v1/RateIQ_WeekDays/save",
    },

    RATEIQ_CUSTOMER_TYPE: {
        GET_LIST: "v1/RateIQ_CustomerType/getlist",
        SAVE: "v1/RateIQ_CustomerType/save",
        DELETE: "v1/RateIQ_CustomerType/delete",
    },

    RATEIQ_LOS: {
        GET_LIST: "v1/RateIQ_Los/getlist",
        SAVE: "v1/RateIQ_Los/save",
        DELETE: "v1/RateIQ_Los/delete",
    },

    RATEIQ_YIELD: {
        GET_LIST: "v1/RateIQ_Yield/getlist",
        SAVE: "v1/RateIQ_Yield/save",
        GET_OCCUPANCY: "rateShop/rateiq_yeild_occupancy",
        GET_OCCUPANCY_BY_DATES: "rateShop/rateiq_yeild_occupancy_bydates",
    },


    STR: {
        DAY_BY_DAY: "widget/dbd_str",
    },

    MONTHLY_SEGMENT_DRILLDOWN: {
        GET_MARKETSEGMENT: "widget/dbd_monthly_drilldown_ms",
        GET_MARKETSEGMENT_DATEWISE: "widget/dbd_monthly_drilldown_ms_datewise",
        GET_RATECODE: "widget/dbd_monthly_drilldown_ratecode",
        GET_COMPANY: "widget/dbd_monthly_drilldown_company",
        GET_GUEST: "widget/dbd_monthly_drilldown_guestname",
    },

    DISPLACEMENT: {
        GET_LIST: "widget/dbd_displacement",
        NEW_DISPLACEMENT_LIST: "widget/dbd_displacement_new",
        DISPLACEMENT_TRANSIENT_FORECAST: "widget/displacement_transient_forecast",
        DISPLACEMENT_TRANSIENT_OTB_FORECAST: "widget/displacement_transient_otb_forecast",
    },

    PROPERTY_NOTIFICATION_CONFIG: {
        GET_LIST: "v1/PropertyNotificationConfig/getlist",
        SAVE: "v1/PropertyNotificationConfig/save",
    },

    CRM_SNAPSHOT: {
        REVENUE_BY_COMPANY: "crm/revenue_by_company",
        REVENUE_BY_ROOMTYPE: "crm/revenue_by_roomType",
        REVENUE_BY_MARKETSEGMENT: "crm/revenue_by_marketsegment",
        CANCELLATION_ACTIVITY: "crm/Cancellation_activity",
        COMPANY_DRILLDOWN: "crm/dbd_company_monthly_drilldown",
        TODAY_ARRIVAL: "crm/today_arrial",
        TODAY_DEPARTURE: "crm/today_departure",
        GET_FLIGHT_DATA: "crm/get_flight_data",
        GET_NEAR_BY_AIRPORT: "crm/get_nearby_airport",
        ANNUAL_SUMMARY_CHAT_BOT: "crm/annual_summary_keypoint",
        OTHER_SUMMARY_CHAT_BOT: "crm/onesummery",
        GET_PROPERTY_STATUS: "crm/property_status",
        GET_THREAD_FOR_CHAT: "crm/threadcreate",
        CREATE_CRM_ASSITANT: "crm/createassistant",
    },

    ZOOM_INFO: {
        SEARCH_COMPANY: "v1/ZoomInfo/searchcompany",
        COMAPNY_DETAILS: "v1/ZoomInfo/companydetails",
        CONTACT_DETAILS: "v1/ZoomInfo/contactdetails",
    },

    CHANNEL_SEGMENT_DRILLDOWN: {
        GET_MONTHLY_CHANNEL: "widget/dbd_channel_monthly_drilldown",
        GET_MONTHLY_RATECODE: "widget/dbd_channel_monthly_drilldown_ratecode",
        GET_MONTHLY_COMPANY: "widget/dbd_channel_monthly_drilldown_company",
        GET_MONTHLY_GUEST: "widget/dbd_channel_monthly_drilldown_guestname",
    },

    REVPAK_EXCEL_EXPORT: {
        GET_EXCEL_FILE: "v1/ExportToExcel/getexcelfile",
        GET_WIDGET_WISE_EXCEL: "v1/ExportToExcel/exportexcelwidgetwise",
    },

    SNAPSHOT_LOG: {
        GET_LOG: "widget/rms_job_list_log",
        GET_WIDGET_DETAILS: "widget/rms_job_widget_status",
    },

    OTHER_NOTES: {
        SAVE: "v1/OtherNotes/save",
    },

    FLIGHT: {
        NEARBYAIRPORT: "v1/Flight/nearbyairport",
        AIRPORTTIMETABLESEARCHMODEL: "v1/Flight/airporttimetablesearchmodel",
    },

    PORTFOLIO_ROLLUP: {
        WIDGET_COUNT: "portfolio/widget_count",
        MONTHLY_SUMMARY_CHART: "portfolio/monthly_summary",
        MONTHLY_SUMMARY_TABLE: "portfolio/monthly_summary_by_dates",
        // MARKET_SEGMENT_WISE_REVENUE: "portfolio/marketsegment_wise_monthly_chart",
        MARKET_SEGMENT_WISE_REVENUE: "portfolio/portfolio_market_segment",
        PORTFOLIO_COMPANY: "portfolio/portfolio_company",
        DAY_BY_DAY: "portfolio/portfolio_day_by_day",
        PORTFOLIO_RATE: "portfolio/portfolio_rate",
        PORTFOLIO_SUMMARY: "portfolio/portfolio_reports",
        BUDGET_RECAP_REPORT: "portfolio/budget_recap_report",
    },

    ARCHIVE: {
        GETLIST: "v1/archivedata/getlist",
        SAVE: "v1/archivedata/save",
        GETARCHIVEHTML: "v1/archivedata/getarchivehtml",
        ARCHIVEDATAFILE_SAVE: "v1/pythoncommon/archivedatafile",
    },

    BOOKING_WINDOW: {
        MONTHLY_BOOKING_PACE: "widget/dbd_monthly_booking_pace",
        DAY_BY_DAY_STLY: "widget/dbd_booking_day_by_day_stly",
        DAY_BY_DAY_STLY_DATEWISE: "widget/dbd_booking_day_by_day_stly_datewise",
        DAY_BY_DAY_PICKUP: "widget/dbd_booking_day_by_day_pickup",
        GET_LIST: "v1/BookingWindow/getlist",
        SAVE: "v1/BookingWindow/save",
    },

    DEMAND_SCORE: {
        GET_DASHBOARD_DATA: "chart/demand_score_simulator",
        GET_CANCELATION_AND_DEMAND_LEVEL_DATA: "v1/KPI/getlistofdemandthresholds",
        SAVE_CANCELATION_AND_DEMAND_LEVEL_DATA: "v1/KPI/savedemandthresholds",
    },

    ANALYTICS: {
        GOOGLE_RATINGS: "chart/propertywise_google_ratings",
        REVIEWS: "chart/propertywise_google_reviews",
        RATES: "chart/propertywise_google_rates",
        RATING_COUNT: "chart/propertywise_google_rates_count",
        SENTIMATE_REVIEW_COUNT: "chart/propertywise_google_sentimentreview_count",
        WORLDCLOUDCHART: "chart/worldcloudchart",
    },

    REVENUE_GLANCE: {
        DASHBOARD: "dashboard/dashboard_revglance",
        COMP_RATE_VARIANCE_WITH_OCC_SELF:
            "dashboard/comp_rate_variance_with_occ_self",
        // HIGH_DEMAND_DATES: "dashboard/highDemandDates", // Old
        // LOW_DEMAND_DATES: "dashboard/lowDemandDates", // Old
        HIGH_DEMAND_DATES: "dashboard/new_highDemandDates", // New
        LOW_DEMAND_DATES: "dashboard/new_lowDemandDates", // New
        TOP_10_EVENT_STRETERGY: "dashboard/top_10_event_strategy",
        CREATE_THREAD_FOR_MODULE: "chatbot/createthreadformodule",
        SEND_MSG_FOR_MODULE: "chatbot/sendmessageformodule",
        FLAG_AI_SUMMARY: "chatbot/flagaisummary",
        TOP_10_MARKET_SEGMENT_DRILLDOWN: "dashboard/top10marketsegment_drilldown",
        TOP_RATECODE_DRILLDOWN: "dashboard/topratecode_drilldown",
    },

    CHATBOT: {
        AI_GENERATED_COMMENT: "chatbot/comments",
    },

    MARKET_SEGMENTATION: {
        SAVE: "v1/MarketSegmentation/save",
        GET: "v1/MarketSegmentation/getlist",
        DELETE: "v1/MarketSegmentation/delete",

        GETLISTTYPICALRANGE: "v1/MarketSegmentation/getlisttypicalrange",
        SAVETYPICALRANGE: "v1/MarketSegmentation/savetypicalrange",

    },

    MONEY_CONTROL: {
        DAILY_PERFORMANCE_DASHBOARD: "chart/daily_performance_dashboard",
        ADR_BY_BOOKINGDATE: "chart/adr_by_bookingdate",
        CANDLE_CHART: "chart/candle_chart",
        MARKETSEGMENT_MIX_CHART: "chart/marketsegment_mix_chart",
        FORECAST_MIX_CHART: "chart/forecast_mix_chart",
        BUDGET_OTB_PACING_MONITER: "chart/budget_otb_pacing_moniter",
    },

    DEMAND_DATA: {
        DEMAND_CALENDAR: "chart/demand_calendar",
    },

    PACEIQ: {
        PACEIQ: "crm/paceiq",
    },
    PRICE_QUALITY_INSIGHTS: {
        PRICE_QUALITY_INSIGHTS: "chart/pricing_vs_quality",
    },
    NODE_EXPORT_WIDGET_WISE_EXCEL: {
        NODE_EXPORT_WIDGET_WISE_EXCEL: "revevolve/excel_sheet",
    },

    // RM-Copilot Endpoints
    RM_COPILOT_CHAT: {
        GET_CHAT_HISTORY: "v1/chat/get_chat",
        STORE_CHAT: "v1/chat/store_chat",
        SOCKET_CHAT: "v1/ws/chat",
    },
    RM_COPILOT_ALERT_AND_SIGNALS: {
        GET_KPI_ALERTS: "chatbot/propertykpialert",
    },
    PRICING_SIMULATOR_RATE: {
        PRICING_SIMULATOR_RATE_GRID: "revevolve/pricing_simulator_rate_grid",
        PRICING_SIMULATOR_RESULT: "revevolve/pricing_simulator_result",
        DBD_PRICING_CURVE: "widget/dbd_pricing_curve",
        WHAT_IF_SIMULATOR_ASSISTANT: "chatbot/what_if_simulator_assistant",
        SINGLE_DAY_RECOMMENDATION: "widget/dbd_single_day_recommendation",
    },

    THIRD_PARTY_API_REQUEST: {
        GET_LIST: "v1/ThirdPartyApiRequest/getlist",
        GETONDEMANDLIST: "v1/ThirdPartyApiRequest/getondemandlist",

        GET_ONDEMAND_LIST: "v1/ThirdPartyApiRequest/getondemandlist",
    },
    ADMINAPI: {
        GETALLWIDGETLIST: "v1/Login/getallwidgetlist",
        MARKETPLACE_LIST: "Login/getallwidgetlist",
        MARKETPLACE_DETAIL: "Login/getwidgetbyid",
        SNAPSHOT_GETALLWIDGETLIST: "v1/Login/getallsnapshlist",
        SNAPSHOT_MARKETPLACE_LIST: "Login/getallsnapshlist",
        SNAPSHOT_MARKETPLACE_DETAIL: "Login/getsnapshotbyid",
        MARKETPLACECHECKOUT: "Public/marketplacecheckout",
        VERIFYPAYMENTCLIENTMARKETPLACE: "Public/verifypaymentclientmarketplace",
        MARKETPLACEDIRECTADD: "Public/MarketPlaceDirectAdd",
    },
    PUBLIC_SUPPORT_TICKET: {
        TICKET_CATEGORIES: "Public/ticketcategories",
        CREATE_TICKET: "Public/createticket",
        GET_LIST: "Public/getlistticket",
        GET_BY_PRIMARY_KEY: "Public/getbyprimarykeyticket",
        REPLY: "Public/replyticket",
    },
    PUBLIC_INVOICE: {
        GET_LIST: "Public/getlistinvoice",
        CREATEPAYMENT: "Public/createpaymentsessionclientinvoice",
        VERIFYPAYMENT: "Public/verifypaymentclientinvoice",
        PAYMENTHISTORY: "Public/getpaymenthistoryinvoice",
        CREATEPAYMENTSESSIONFORHOTELRATESHOPCREADIT: "Public/createpaymentsessionforhotelrateshopcreadit",
        VERIFYPAYMENTFORHOTELRATESHOPCREADIT: "Public/verifypaymentforhotelrateshopcreadit",
    },

    GROUP_WASH: {
        GROUP_WASH_ANALYSIS: "snapshot/snp_group_wash_analysis",
        GROUP_WASH_SAVE: "snapshot/snp_group_user_wash",

        // GROUP_WASH_PICKUP: "widget/dbd_group_pickup",
        GROUP_WASH_PICKUP: "group/dbd_group_pickup",
        // GROUP_WASH_OTB: "widget/dbd_group_otb",
        GROUP_WASH_OTB: "group/dbd_group_otb",
        // GROUP_WASH_ANALYSIS_SAVE: "widget/dbd_group_wash_analysis",
        GROUP_WASH_ANALYSIS_SAVE: "group/dbd_group_wash_analysis",
        // GROUP_WASH_GROUP_TRANSIENT_DRILLDOWN_SUMMARY: "group/snapshot/snp_group_transient_drilldown",
        GROUP_WASH_GROUP_TRANSIENT_DRILLDOWN_SUMMARY: "group/snp_group_transient_drilldown",
    },

    MORNING_BRIEFING: {
        GET_MARKET_SHARE: "snapshot/snp_trailing_star",
        GET_CHANNEL_MIX: "rateShop/channel_mix_14day_trend",
        GET_WEEKLY_CANCELLATIONS: "widget/weekly_cancellation_90_days",
        GET_HIGH_DEMAND_GROUP: "dashboard/dbd_high_demand_group",
        DAILY_CANCELLATIONS_90_DAYS: "widget/daily_cancellation_90_days",
    },

    RATE_DISTRIBUTION: {
        GET_ACTIVE_CM_CONNECTION: "ratedistribution/active_cm_connection",
        CREATE_CM_CONNECTION: "ratedistribution/create_cm_connection",
        DELETE_CM_CONNECTION: "ratedistribution/delete_cm_connection",
        FETCH_ROOM_TYPE: "ratedistribution/fetch_room_type",
        FETCH_RATE_PLAN: "ratedistribution/fetch_rate_plan",
        FETCH_RATE_DATA: "ratedistribution/fetch_rate_data",
        PROPOSE_RATE: "ratedistribution/propose_rate",
        CONFIRM_PROPOSAL: "ratedistribution/confirm_proposal",
        CANCEL_PROPOSAL: "ratedistribution/cancel_proposal",
        ROLLBACK_RATE: "ratedistribution/rollback_rate",
        LIST_PROPOSALS: "ratedistribution/list_proposals",
        PUSH_HISTORY: "ratedistribution/push_history",
    },
    
    YIELD_RADAR : {
      RESERVATION_DATA : "widget/get_yield_radar_reservation_data"
    },

    WIDGET_CONFIG: {
        GET: "widget/get_widget_config",
        SET: "widget/set_widget_config",
    },
};
